import { createAction, props, union } from '@ngrx/store';

import { TripType } from '@fcom/core/constants';
import { GlobalBookingTravelClass } from '@fcom/core';
import { GlobalBookingTripDates } from '@fcom/common';
import { LocationRouteType } from '@fcom/core-api/interfaces';
import { PaxAmount } from '@fcom/dapi/interfaces';
import { PreviousSearch } from '@fcom/booking-widget/interfaces';

import { LocationPair } from '../store.interface';

export const setDates = createAction('[GlobalBookingActions] SetDates', props<{ dates: GlobalBookingTripDates }>());

export const setTripType = createAction('[GlobalBookingActions] SetTripType', props<{ tripType: TripType }>());

export const setTravelClass = createAction(
  '[GlobalBookingActions] SetTravelClass',
  props<{ travelClass: GlobalBookingTravelClass }>()
);

export const setOrigin = createAction('[GlobalBookingActions] SetOrigin', props<{ origin: string }>());

export const setRouteType = createAction(
  '[GlobalBookingActions] SetRouteType',
  props<{ routeType: LocationRouteType }>()
);

export const increasePaxAmountField = createAction(
  '[GlobalBookingActions] IncreasePaxAmountField',
  props<{ field: string; increment: number }>()
);

export const decreasePaxAmountField = createAction(
  '[GlobalBookingActions] DecreasePaxAmountField',
  props<{ field: string; decrement: number }>()
);

export const setDiscountCode = createAction(
  '[GlobalBookingActions] SetDiscountCode',
  props<{ discountCode: string }>()
);

export const setSelection = createAction('[GlobalBookingActions] SetSelection', props<{ selection: PreviousSearch }>());

export const setPaxAmount = createAction('[GlobalBookingActions] SetPaxAmount', props<{ paxAmount: PaxAmount }>());

export const setLocations = createAction('[GlobalBookingActions] SetLocations', props<{ locations: LocationPair[] }>());

export const updateLocationPair = createAction(
  '[GlobalBookingActions] UpdateLocationPair',
  props<{ locationPair: LocationPair; index: number }>()
);

export const paymentVerified = createAction('[GlobalBookingActions] HandlePaymentStatus');

export const resetSelection = createAction('[GlobalBookingActions] ResetSelection');

const all = union({
  setDates,
  setTripType,
  setTravelClass,
  setOrigin,
  setRouteType,
  setPaxAmount,
  decreasePaxAmountField,
  increasePaxAmountField,
  setDiscountCode,
  setSelection,
  setLocations,
  updateLocationPair,
  paymentVerified,
  resetSelection,
});

export type GlobalBookingActionsUnion = typeof all;
